import axios from "axios";
import { isPublicPath } from "./seo/publicRoutes";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BASE}/api`,
});

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ct_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Global response interceptor — handle auth/permission errors
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem("ct_token");
      localStorage.removeItem("ct_selected_device");
      
      // Do not force redirect if we are already on a public page
      const isPublic = isPublicPath(window.location.pathname);
      
      if (!isPublic) {
        window.location.assign("/login");
      }
    }
    if (status === 403) {
      // Dispatch custom event so device context / screens can react
      window.dispatchEvent(new CustomEvent("ct:device-forbidden", {
        detail: { url: err?.config?.url, message: err?.response?.data?.detail },
      }));
    }
    return Promise.reject(err);
  }
);

export function setToken(t) {
  if (t) localStorage.setItem("ct_token", t);
  else localStorage.removeItem("ct_token");
}
export function getToken() {
  return localStorage.getItem("ct_token");
}

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
  return err?.message || "Something went wrong";
}
